module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"medical_assessment":"Medical Assessment"},"fr":{"medical_assessment":"Évaluation médicale"}}')
  delete Component.options._Ctor
}
